import https from "https";
import { PDFDocument } from "pdf-lib";

const downloadPDF = (url) => {
  return new Promise((resolve, reject) => {
    https.get(url, (response) => {
      const chunks = [];
      response.on('data', chunk => chunks.push(chunk));
      response.on('end', () => resolve(Buffer.concat(chunks)));
      response.on('error', reject);
    });
  });
};

const processLinkGroup = async (links) => {
  return await Promise.all(links.map(url => downloadPDF(url)));
};

export const mergeDLPDFs = async (links, name) => {
  try {
    // Split links into groups of 10
    const groupSize = 10;
    const linkGroups = [];
    for (let i = 0; i < links.length; i += groupSize) {
      linkGroups.push(links.slice(i, i + groupSize));
    }

    // Process each group with Promise.all
    const groupResults = await Promise.all(linkGroups.map(group => processLinkGroup(group)));
    // Flatten the results
    const pdfBuffers = groupResults.flat();

    // Merge PDFs
    const mergedPdf = await PDFDocument.create();
    for (const buffer of pdfBuffers) {
      try {
        const pdf = await PDFDocument.load(buffer);
        const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
        pages.forEach(page => mergedPdf.addPage(page));
      } catch (err) {
        console.log('Corrupted PDF data, skipping:', err.message);
      }
    }

    // Send merged PDF directly
    const pdfBytes = await mergedPdf.save();
    const newBlob = new Blob([pdfBytes], { type: "application/pdf" });
    const data = window.URL.createObjectURL(newBlob);
    const link = document.createElement("a");
    link.href = data;
    link.download = name + ".pdf";
    link.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(data);
    }, 100);
    return true;
  } catch (error) {
    console.error('Error merging PDFs:', error);
    return false;
  }
};